import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { SessionInvitesStatus } from "@classview/shared-types";

type OrganisationsListProps = {
  organisations: {
    name: string;
    id: string;
    status: SessionInvitesStatus;
  }[];
};

/**
 * Displays a list of invited organisations in the session single view.
 * This is NOT an edit/form component.
 */
export function OrganisationsList(props: OrganisationsListProps) {
  const { organisations } = props;

  return (
    <ScrollArea
      type="always"
      className={cn("rounded-md border border-border", {
        "h-[427px]": organisations.length > 7, // 7 items * 61px = 427px
      })}
    >
      <div className="divide-y divide-border">
        {organisations.map((org) => (
          <div
            key={org.id}
            className="flex items-center justify-between px-4 py-2"
          >
            <div className="flex min-w-0 items-center">
              <div className="ml-2 min-w-0">
                <p className="text-foreground">{org.name}</p>
                {org.status === "ACCEPTED" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-green-500" />
                      Accepted
                    </span>
                  </Badge>
                )}
                {org.status === "PENDING" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-warning" />
                      Pending
                    </span>
                  </Badge>
                )}
                {org.status === "REJECTED" && (
                  <Badge variant="outline">
                    <span className="flex items-center">
                      <span className="mr-2 inline-block size-2 rounded-full bg-red-500" />
                      Rejected
                    </span>
                  </Badge>
                )}
                {org.status === "HOST" && (
                  <Badge variant="outline">Host </Badge>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
